<template>
    <div>
        <PCIndex 
            class="pcindex"
            v-if=" exampleList != '' && isMobile === false" 
            :exampleList="exampleList" 
        />

        <MobileIndex 
            v-else-if=" exampleList != '' && isMobile" 
            :exampleList="exampleList" 
        />
    </div>

</template>
<script>
import PCIndex from '@/components/pc/PCIndex'
import MobileIndex from '@/components/mobile/MobIndex'

// import jquery from 'jquery'

import indexJson from '@/json/index'

export default {

    name: 'Index',
    props: {
        isMobile: Boolean
    },
    data: function(){
        return {
            exampleList: indexJson.getAjaxJson,
            getInfor: true,
            swiper: {
                index: null
            },
            serveURL: this.GLOBAL.serveURL
        }
    },       
    components: {
        PCIndex,
        MobileIndex
    },
    mounted() {    
        // console.log(this.exampleList); 
        // 本地 jq 获取数据
        // let _this = this;
        // window.getAjaxJson = [];
        // jquery.get(this.serveURL + 'index.js', function(){
        //    _this.exampleList =  window.getAjaxJson;
        //    _this.getInfor = true;
        // });
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
</style>